import Vue from "vue";
import VueRouter from "vue-router";
import Homepage from "./layouts/Homepage.vue";
import Experience from "./layouts/Experience.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    { path: "/", component: Homepage },
    { path: "/swatch-my-own", component: Experience }
  ]
});

export default router;
